import { IAppState } from '../../../AppModulesWrapper';

import { selectIsNewOffer } from '../offer';
import { selectIsPublishToHiddenBase } from '../publishAvailable';

export function selectPublicationButtonText(state: IAppState): string {
  const { submitText } = state.servicePickerWidget.checkoutInfo;
  const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);
  const isNewOffer = selectIsNewOffer(state);

  const submitTextFallback = isNewOffer ? 'Разместить' : 'Сохранить изменения';

  return (
    (!isPublishToHiddenBase &&
      // В обычной ситуации берём текст для кнопки из check-service
      submitText) ||
    // В случаях, когда check-service не вызывается (публикация в скрытую базу,
    // флоу Сделки в аренде или просто поле не имеет значения), возвращаем фолбэк
    submitTextFallback
  );
}
